// extracted by mini-css-extract-plugin
export default {"root":"Tooltip_root__04h97","primary":"Tooltip_primary__l8QV1","secondary":"Tooltip_secondary__UYxpc","wrapper":"Tooltip_wrapper__-Vvjj"};